import { Deserializable } from '../protocols/deserializable';
import { InvestmentInstructionSubmissionAffectedAccount } from './investment-instruction-submission-affected-account';
import { InvestmentInstructionSubmissionData } from './investment-instruction-submission-data';
import { AccountTypeIdEnum } from '../enum/shared/account-type-id.enum';
import { AccountType } from '../transactions/account-type';

export class InvestmentInstructionSubmission implements Deserializable {
  public previous!: InvestmentInstructionSubmissionData;
  public new!: InvestmentInstructionSubmissionData;
  public affectedAccounts!: InvestmentInstructionSubmissionAffectedAccount[];
  public accountTypeId!: AccountTypeIdEnum;
  public accountType!: AccountType;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;

    if (!!this.previous) {
      this.previous = Deserialize.instanceOf(InvestmentInstructionSubmissionData, this.previous);
    }

    if (!!this.new) {
      this.new = Deserialize.instanceOf(InvestmentInstructionSubmissionData, this.new);
    }

    if (!!this.affectedAccounts) {
      this.affectedAccounts = Deserialize.arrayOf(
        InvestmentInstructionSubmissionAffectedAccount,
        this.affectedAccounts
      );
    }

    if (!!this.accountType) {
      this.accountType = Deserialize.instanceOf(AccountType, this.accountType);
    }
  }
}
